import { onReady } from '../lib/on-ready.js';
import { onActivateKey } from '../lib/keyboard.js';

function initMarquee() {
    document.querySelectorAll('.marquee-pause-button').forEach((button) => {
        const marqueeContent = button.closest('.marquee-component')?.querySelector('.marquee-content');
        if (!marqueeContent) {
            return;
        }

        button.addEventListener('click', () => {
            const isPaused = marqueeContent.classList.contains('paused');
            if (isPaused) {
                marqueeContent.classList.remove('paused');
                button.setAttribute('aria-label', 'Stop marquee animation');
                button.setAttribute('title', 'Stop marquee animation');
                button.classList.remove('paused');
            } else {
                marqueeContent.classList.add('paused');
                button.setAttribute('aria-label', 'Resume marquee animation');
                button.setAttribute('title', 'Resume marquee animation');
                button.classList.add('paused');
            }
        });

        onActivateKey(button, () => button.click());
    });
}

onReady(initMarquee);
